import React from 'react';
import type { ProfessionalLocation } from '@modules/category/type';

interface LocationListProps {
    category: string;
    locations: ProfessionalLocation[];
}

const CategoryPageLocations = ({ category, locations }: LocationListProps) => {
    if (locations.length == 0) {
        return null;
    }

    // Number of columns in the list, used for columns and how many top borders
    const COLUMN_COUNT = 4;

    return (
        <div className="md:mb-spacing-page-category-gap-component-s relative flex flex-col gap-10 px-6 md:px-12">
            <h2 className="text-6 font-medium tracking-[0.025rem] md:left-12">
                Browse Locations
            </h2>
            <ul
                className={`grid grid-cols-1 gap-5 md:grid-cols-${COLUMN_COUNT}`}
            >
                {locations.map((location, index) => (
                    <li
                        key={location.ID}
                        className={`${index < COLUMN_COUNT ? 'border-gray-200 md:border-t md:pt-3' : ''}`}
                    >
                        <a
                            href={location.Link}
                            className="line-clamp-6 cursor-pointer font-sans text-base leading-[1.3] text-gray-800 hover:underline"
                        >
                            {category} in {location.Title}
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default CategoryPageLocations;
